module.exports = __webpack_public_path__ + "img/image_part_006.29af203d.jpg";